import React, { Component } from 'react';
import { Menu, Icon, Table, Button, Modal, Spin, Row, Col, Input, Pagination } from 'antd';
import moment from 'moment';
import _ from 'lodash';
import cn from 'classnames';
// import { formItemLayout } from 'constants/layout';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';

// import { getPaymentVouchers } from 'redux/modules/transaction';
import { getPaymentVouchers } from 'data/transaction';

import Utils from 'utils/utils';

import { exportAsExcel } from 'helpers/Table';
// import Utils from 'utils/utils';
import { DatePickerInput } from '../../components';
import classes from '../styles/PaymentVouchers.module.scss';
// import classes from './PaymentVouchers.scss';

import COLUMNS from './PVRVColumns';

const pageLimit = 20;
const Confirm = Modal.confirm;

class PaymentVounchers extends Component {
  constructor(props) {
    super(props);
    this.changeFocusPage = this.changeFocusPage.bind(this);
    this.onChangePage = this.onChangePage.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onInputSearch = this.onInputSearch.bind(this);
    this.onSearchInputPress = this.onSearchInputPress.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    const start = props.location.query.start ? moment(props.location.query.start, 'DD-MM-YYYY') : moment().subtract(1, 'month');
    const end = props.location.query.end ? moment(props.location.query.end, 'DD-MM-YYYY') : moment();

    this.state = {
      collapseMobile: [],
      showModal: false,
      page: props.page,
      displaySearchValue: '',
      selectedRowKeys: [],
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      searchValue: props.location.query.q ? props.location.query.q : '',
      start,
      end,
    };
  }

  componentDidMount = async () => {
    const query = this.props.location.query;

    this.setState({
      loading: true,
    });

    const paymentVouchers = await getPaymentVouchers(query);

    this.setState({
      loading: false,
      paymentVouchers: paymentVouchers.results,
      page: paymentVouchers.currentPage,
      count: paymentVouchers.count,
    });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  componentWillReceiveProps(props) {
    this.setState({
      selectedStatus: props.location.query.status ? props.location.query.status : 'all',
      sortBy: props.location.query.sortBy ? props.location.query.sortBy : undefined,
      searchValue: props.location.query.q ? props.location.query.q : '',
      page: props.location.query.page ? parseInt(props.location.query.page, 10) : 1,
    });
  }

  onChangePage(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getPaymentVouchers(_.merge(this.getCurrentQuery(), { page }));
      },
    );
  }

  onSearch() {
    this.setState(
      {
        page: 1,
        searchValue: this.state.displaySearchValue,
      },
      () => {
        this.getPaymentVouchers(_.merge(this.getCurrentQuery(), { q: this.state.displaySearchValue })).then((response) => {
          console.log(response);
        });
      },
    );
  }

  onInputSearch(event) {
    this.setState({
      displaySearchValue: event.target.value,
    });
  }

  onSearchInputPress(event) {
    if (event.charCode === 13) {
      this.onSearch();
    }
  }

  onTableChange(a, b, sorter) {
    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ sortBy: `-${field}` }, this.onSearch);
    } else if (order === 'ascend') {
      this.setState({ sortBy: field }, this.onSearch);
    }
  }

  getCurrentQuery() {
    return {
      page: this.state.page,
      status: this.state.selectedStatus,
      q: this.state.searchValue,
      start: this.state.start.format('DD-MM-YYYY'),
      end: this.state.end.format('DD-MM-YYYY'),
      sortBy: this.state.sortBy,
    };
  }

  getPaymentVouchers = async (query) => {
    this.setState({
      loading: true,
    });

    const paymentVouchers = await getPaymentVouchers(query);

    this.setState({
      loading: false,
      paymentVouchers: paymentVouchers.results,
      page: paymentVouchers.currentPage,
      count: paymentVouchers.count,
    });
    browserHistory.push(`${this.props.location.pathname}${Utils.createQueryString(query)}`);
  };

  changeFocusPage(event) {
    const status = event.key;

    this.getPaymentVouchers(_.merge(this.getCurrentQuery(), { status, page: 1 })).then((response) => {
      console.log(response);
    });
    this.setState({
      selectedStatus: status,
      selectedRowKeys: [],
      page: 1,
    });
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  exportToExcel = async () => {
    this.setState({
      loading: true,
    });

    const paymentVouchers = await getPaymentVouchers(_.merge(this.getCurrentQuery(), { limit: 10000 }));

    const content = _.map(paymentVouchers.results, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });
    exportAsExcel({
      filename: `PV-${moment().format('DD-MM-YYYY_HH-mm-ss')}.xlsx`,
      sheetName: 'Sheet1',
      columns: COLUMNS.PVCOLUMNS,
      data: content,
    });
    this.setState({
      loading: false,
    });
  };

  menus = [
    { label: 'All', value: 'all', column: 'all' },
    { label: 'Kbank', value: 'recommend', column: 'all' },
    { label: 'BBL', value: 'rejected', column: 'all' },
  ];

  renderContentTable() {
    const content = _.map(this.state.paymentVouchers, (singleContent, key) => {
      singleContent.key = key;
      return singleContent;
    });

    return (
      <div>
        <Table columns={COLUMNS.PVCOLUMNS} dataSource={content} bordered pagination={false} onChange={this.onTableChange} scroll={{ x: 1400 }} />
        <Pagination className={cn(classes.pagination, 'text-right')} current={this.state.page} onChange={this.onChangePage} defaultPageSize={pageLimit} total={this.state.count} />
      </div>
    );
  }

  render() {
    const { loading } = this.state;
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!loading}>
            <div className={classes.searchContainer}>
              <Row>
                <Col xs={7} className={classes.searchInputContainer}>
                  <span>
                    <Input prefix={<Icon type="search" />} placeholder="Search" onKeyPress={(e) => this.onSearchInputPress(e)} onChange={(e) => this.onInputSearch(e)} />
                  </span>
                </Col>
                <Col xs={7}>
                  <span>
                    <DatePickerInput start={this.state.start} end={this.state.end} onChange={(momentDates) => this.setState({ start: momentDates[0], end: momentDates[1] })} />
                  </span>
                </Col>

                <Button className="search-btn" onClick={this.onSearch}>
                  <Icon type="search" />
                </Button>
              </Row>
            </div>
            <div className="text-right">
              <a onClick={() => this.exportToExcel()}>Export to excel</a>
            </div>
            {this.renderContentTable()}
          </Spin>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({}), {})(PaymentVounchers);
